import styled from "styled-components";

import color from "../_style/color";

const sizes = {
  small: "8px",
  medium: "12px",
  large: "16px",
};

const ConnectionIndicator = styled.div.attrs((props) => ({
  size: props.size || "medium",
  isConnected: props.isConnected || false,
}))`
  border-radius: 50%;
  height: ${({ size }) => sizes[size]};
  width: ${({ size }) => sizes[size]};

  background-color: ${({ isConnected }) => (isConnected ? color.primary : color.sunsetOrange)};
`;

export default ConnectionIndicator;
